<script>
import { Table } from 'element-ui';
import TableHeader from './table/header';
import TableBody from './table/body';

export default {
  components: {
    TableHeader,
    TableBody,
  },
  extends: Table,
};
</script>

<style lang="scss">
.el-table {
  font-size: rem(14px);

  @media only screen and (max-width: $--breakpoint-sm - 1) {
    margin-left: 0;
    margin-right: 0;
  }

  &::before {
    content: none;
  }

  td {
    padding: rem(6px) 0;
    border-top: 1px solid $--border-color-base;

    @media only screen and (min-width: $--breakpoint-sm) {
      &:first-of-type {
        padding-left: 0;
      }

      &:last-of-type {
        padding-right: 0;
      }
    }

    @media only screen and (max-width: $--breakpoint-sm - 1) {
      &:first-of-type {
        padding-left: rem(10px);
      }
    }

    .cell {
      padding-left: rem(8px);
      padding-right: rem(8px);
      word-wrap: break-word;
    }

    &:first-of-type > .cell {
      padding-left: rem(10px);
      padding-right: 0;
    }
  }

  .cell {
    position: relative;
    white-space: normal;
    word-break: normal;
  }

  .caret-wrapper {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .sort-caret.ascending {
    top: 7px;
    border-bottom-color: $--color-gray-8;
  }

  .sort-caret.descending {
    bottom: 5px;
    border-top-color: $--color-gray-8;
  }

  .ascending .sort-caret.ascending {
    border-bottom-color: $--color-white;
  }

  .descending .sort-caret.descending {
    border-top-color: $--color-white;
  }

  .el-checkbox {
    top: rem(2);
  }

  .el-table-column--selection .cell {
    text-overflow: initial;
  }

  .el-table__column-number .cell {
    a {
      white-space: nowrap;
    }
  }

  .el-table__column-eet {
    .cell {
      padding: 0 rem(25) 0 0;
    }

    .icon {
      padding: rem(3);
      width: rem(20);
      height: rem(20);
      font-size: rem(10);
      font-weight: 600;
      display: inline-flex;
      align-items: center;
      border: 2px solid #c3c8ce;
      border-radius: 50%;
      color: #c3c8ce;
      letter-spacing: -1px;
    }

    .icon-cross {
      color: #d70000;
    }

    .icon-minus {
      color: #c3c8ce;
    }

    .icon-check {
      color: #40d0ad;
    }
  }

  .el-table__column-state > .cell {
    overflow: visible;
  }

  .el-button--icon {
    padding-left: rem(6px);
    padding-right: rem(6px);
  }

  .el-button + .el-button {
    margin-left: 0;
  }

  .el-button--icon:not(.el-button--new-design) .icon {
    font-size: rem(15px);
  }

  .el-table__expanded-cell {
    padding-left: rem(4px);
    padding-right: rem(4px);

    &:first-of-type {
      padding-left: rem(12px);
      padding-right: rem(12px);
    }
  }

  .el-table__expand-icon {
    height: 40px;

    & > .el-icon {
      color: $--color-primary;
      font-size: rem(24px);
      margin: 0;
      left: -2px;
      top: 50%;
      transform: translateY(-50%) rotate(90deg);
      transition: transform .15s ease;
    }

    &.el-table__expand-icon--expanded {
      transform: rotate(0);

      & > .el-icon {
        transform: translateY(-50%) rotate(-90deg);
        transition: transform .15s ease;
      }
    }
  }

  th {
    padding-top: rem(12);
    padding-bottom: rem(12);
    border-top: 0;

    &.el-table__cell {
      background-color: $--color-white;
      color: $--color-text-regular;
      border-top: 1px solid $--border-color-base;
      font-weight: 600;
    }

    @media only screen and (min-width: $--breakpoint-sm) {
      &:first-of-type {
        padding-left: 0;
      }

      &:last-of-type {
        padding-right: 0;
      }
    }

    @media only screen and (max-width: $--breakpoint-sm - 1) {
      &:first-of-type {
        padding-left: 0;
      }
    }

    .el-checkbox {
      .el-checkbox__inner {
        background-color: $--color-white;
        border-color: $--border-color-base;
      }

      &:hover {
        .el-checkbox__inner {
          background-color: $--color-white;
          border-color: $--color-primary;
        }
      }

      &.is-checked,
      .el-checkbox__input.is-indeterminate {
        .el-checkbox__inner {
          background-color: $--color-primary;
          border-color: $--color-primary;

          &::after {
            border-color: $--color-white;
          }
        }
      }
    }
  }

  th.el-table__cell > .cell {
    font-size: rem(12px);
    font-weight: 600;
    width: auto;
    display: inline-block;
    padding-right: 25px;
  }

  th.el-table__cell:last-of-type > .cell {
    padding-right: rem(8px);
  }

  .el-table__header,
  .el-table__body,
  .el-table__footer {
    overflow-y: scroll;
  }
}

.el-table__empty {
  padding-bottom: rem(30px);
  text-align: center;
}

.el-table__empty-block {
  width: 100% !important;
  height: auto !important;
}

.el-table__empty-text {
  max-width: 100vw;
  font-size: rem(18px);
  line-height: 150%;
  width: 100%;
  padding: rem(40px) rem(30px) rem(30px) rem(15px);
}

/* stylelint-disable declaration-no-important */

.el-table__fixed-right::before {
  background-color: transparent !important;
}

.el-table--new {
  tr.el-table__row {
    &:last-of-type td.el-table__cell {
      border-bottom: 1px solid $--border-color-base;
    }

    &.hover-row > td.el-table__cell {
      background-color: $--color-background;
    }
  }

  th.el-table__cell {
    height: rem(44px);
    padding-top: rem(6px);
    padding-bottom: rem(6px);

    .cell {
      padding-left: rem(12px);
    }

    &:last-of-type .cell {
      padding-right: rem(12px);
    }
  }

  td.el-table__cell {
    padding-top: rem(8px);
    padding-bottom: rem(8px);

    .cell {
      padding-left: rem(12px);
      padding-right: rem(12px);
    }
  }
}

.el-table--mobile {
  .el-table__header,
  .el-table__body,
  .el-table__footer {
    min-width: unset;
  }

  th.el-table__cell {
    &:last-of-type .cell {
      padding-right: rem(25px);
    }
  }

  td.el-table__cell {
    .cell {
      padding-left: rem(4px);
      padding-right: rem(4px);
    }
  }
}

.el-table--enable-row-hover {
  .el-table__body tr:hover > td.el-table__cell {
    background-color: $--color-background;
  }
}
</style>
